import { IInvoiceData, IInvoiceItemData } from '@/models';
import {
  IFetchInvoicesParams,
  IInvoiceService,
  IInvoicePaginatedListData
} from './invoice.types';
import { AxiosInstance } from 'axios';
import { axios } from '@/plugins/axios';

export class InvoiceService implements IInvoiceService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/invoices/';
  }

  fetchInvoices(
    params: IFetchInvoicesParams
  ): Promise<IInvoicePaginatedListData> {
    return this.axios
      .get<IInvoicePaginatedListData>(`${this.endpoint}`, {
        params
      })
      .then(({ data }) => data);
  }

  fetchInvoice(id: number): Promise<IInvoiceData> {
    return this.axios
      .get<IInvoiceData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createInvoice(data: IInvoiceData): Promise<IInvoiceData> {
    return this.axios
      .post<IInvoiceData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateInvoice(data: IInvoiceData): Promise<IInvoiceData> {
    return this.axios
      .patch<IInvoiceData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteInvoice(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  updateInvoiceState(id: number, state: number): Promise<IInvoiceData> {
    return this.axios
      .put<IInvoiceData>(`${this.endpoint}${id}/set_state/${state}/`)
      .then(({ data }) => data);
  }

  exportInvoice(invoiceId: number): Promise<Blob> {
    return this.axios
      .get(`${this.endpoint}${invoiceId}/generate-pdf/`, {
        responseType: 'blob'
      })
      .then(({ data }) => data);
  }

  //Item
  fetchInvoiceItems(invoiceId: number): Promise<IInvoiceItemData[]> {
    return this.axios
      .get<IInvoiceItemData[]>(`${this.endpoint}${invoiceId}/items/`)
      .then(({ data }) => data);
  }

  fetchInvoiceItem(invoiceId: number, id: number): Promise<IInvoiceItemData> {
    return this.axios
      .get<IInvoiceItemData>(`${this.endpoint}${invoiceId}/items/${id}/`)
      .then(({ data }) => data);
  }

  createInvoiceItem(
    invoiceId: number,
    data: IInvoiceItemData
  ): Promise<IInvoiceItemData> {
    return this.axios
      .post<IInvoiceItemData>(`${this.endpoint}${invoiceId}/items/`, data)
      .then(({ data }) => data);
  }

  updateInvoiceItem(
    invoiceId: number,
    data: IInvoiceItemData
  ): Promise<IInvoiceItemData> {
    return this.axios
      .patch<IInvoiceItemData>(
        `${this.endpoint}${invoiceId}/items/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deleteInvoiceItem(invoiceId: number, id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${invoiceId}/items/${id}/`);
  }
}

const invoiceService = new InvoiceService(axios);
export default invoiceService;
